var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-result",style:({ width: _vm.width + 'px', height: _vm.height + 'px' })},[_c('div',{ref:"graphChart",staticClass:"graph",style:({ width: _vm.width + 'px', height: _vm.height + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }